var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { role: "main" } }, [
    _vm.user
      ? _c(
          "div",
          [
            _c("h1", [
              _vm._v(
                _vm._s(_vm.$t("Registration.Welcome", { name: _vm.user.name }))
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mb-4" }, [
              _vm._v(
                _vm._s(_vm.$t("Registration.BasicUser.ConfirmationDescription"))
              )
            ]),
            _vm._v(" "),
            _c("text-label-row", {
              attrs: {
                title: "Registration.FullName",
                id: "name",
                labelClass:
                  "col-12 col-md-4 col-lg-3 col-form-label pb-0 pb-md-2",
                valueClass: "col-12 col-md-8 col-lg-9 pt-0 pt-md-2"
              },
              model: {
                value: _vm.user.name,
                callback: function($$v) {
                  _vm.$set(_vm.user, "name", $$v)
                },
                expression: "user.name"
              }
            }),
            _vm._v(" "),
            _c("text-label-row", {
              attrs: {
                title: "Registration.Email",
                id: "email",
                labelClass:
                  "col-12 col-md-4 col-lg-3 col-form-label pb-0 pb-md-2",
                valueClass: "col-12 col-md-8 col-lg-9 pt-0 pt-md-2"
              },
              model: {
                value: _vm.user.userName,
                callback: function($$v) {
                  _vm.$set(_vm.user, "userName", $$v)
                },
                expression: "user.userName"
              }
            }),
            _vm._v(" "),
            _c("text-label-row", {
              attrs: {
                title: "Registration.OrganisationName",
                id: "email",
                labelClass:
                  "col-12 col-md-4 col-lg-3 col-form-label pb-0 pb-md-2",
                valueClass: "col-12 col-md-8 col-lg-9 pt-0 pt-md-2"
              },
              model: {
                value: _vm.user.organisationName,
                callback: function($$v) {
                  _vm.$set(_vm.user, "organisationName", $$v)
                },
                expression: "user.organisationName"
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary mt-4 mb-5 login-page-button",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.toFrontPage()
                  }
                }
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("Registration.Btn_ToFrontPage")) +
                    "\n    "
                )
              ]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }